(function () {
  'use strict';
  function init(scope) {
    var form = scope.querySelector('[data-pf-results-form]');
    if (form && !form.dataset.bound) {
      form.dataset.bound = 'true';
      var input = form.elements.q;
      var clear = form.querySelector('[data-pf-results-clear]');
      function sync() { clear.hidden = !input.value; }
      input.addEventListener('input', sync);
      clear.addEventListener('click', function () {
        input.value = '';
        sync();
        input.focus();
      });
      form.addEventListener('submit', function (event) {
        input.value = input.value.trim();
        if (!input.value) { event.preventDefault(); input.focus(); }
      });
      sync();
    }
    var back = document.querySelector('[data-pf-search-back]');
    if (back && !back.dataset.bound) {
      back.dataset.bound = 'true';
      back.addEventListener('click', function (event) {
        if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        try {
          if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) {
            event.preventDefault();
            history.back();
          }
        } catch (error) {}
      });
    }
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
